import DownloadIcon from "@mui/icons-material/GetApp";
import { Tooltip, Typography } from "@mui/material";
import { ExportButton, useListContext } from "react-admin";

const CustomExportButton = ({ ...props }) => {
  const { total } = useListContext();
  return (total ?? 0) === 0 || (total ?? 0) > 1000 ? (
    <Tooltip
      title={
        (total ?? 0) > 1000
          ? "Records over 1000 in total cannot be exported.  Please use the downloadable reports instead."
          : "No records to export."
      }
      placement="left"
    >
      <Typography
        sx={{
          color: "rgba(0, 0, 0, 0.26)",
          textTransform: "uppercase",
          padding: "4px 5px",
          borderRadius: "10px",
          fontSize: "0.875rem",
          fontFamily: "Gotham Rounded",
          fontWeight: "bold",
          width: "120px",
          cursor: "pointer",
          minWidth: "120px",
          textAlign: "center",
        }}
      >
        <DownloadIcon sx={{ fontSize: "20px", verticalAlign: "bottom" }} />
        Export
      </Typography>
    </Tooltip>
  ) : (
    <ExportButton
      label="Export"
      id="btn-list-export"
      icon={<DownloadIcon />}
      sx={{
        width: "120px",
        minWidth: "120px",
        color: "primary.main",
      }}
      disabled={(total ?? 0) === 0 || (total ?? 0) > 1000}
      maxResults={1000}
    />
  );
};

export default CustomExportButton;
